import { render, staticRenderFns } from "./UserVideo.vue?vue&type=template&id=77524732&"
import script from "./UserVideo.vue?vue&type=script&lang=js&"
export * from "./UserVideo.vue?vue&type=script&lang=js&"
import style0 from "./UserVideo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports